module.exports = __webpack_public_path__ + "media/images/flags/16/Guinea-Bissau-212b19f739fad1fda9e8ea218429c3db.png";